import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {OckImportComponent} from "../ock-import/ock-import.component";
import {OckImport} from "../../../shared/interface/ock-import";
import {
  IMPORT_STATUS_IN_PROGRESS
} from '../../../shared/services/dict.service';
import {OckImportService} from "../../../shared/services/ock-import.service";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";

@Component({
  selector: 'app-all-ock-import-list',
  templateUrl: './all-ock-import-list.component.html',
  styleUrls: ['./all-ock-import-list.component.scss']
})
export class AllOckImportListComponent implements AfterViewInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  userPermissions: ReplaySubject<UserPermissions>;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  initialFilters: any;
  readonly IMPORT_STATUS_IN_PROGRESS = IMPORT_STATUS_IN_PROGRESS;
  imports: OckImport[] = [];
  displayedColumns: string[] = [
    'nip', 'vin', 'fileName',
    'createdAt', 'createdBy', 'status'
  ];
  totalData = 0;




  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private importService: OckImportService,
) {
    this.userPermissions = auth.getUserPermissions();
    this.importService.importListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<OckImport>) => {
          this.imports = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({}, filters);
  }

  filter(): void {
    if (this.paginator.pageIndex === 0) {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value
      })]);
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value,
      })]);
    }
  }

  onImgError($event: ErrorEvent): void {
    // @ts-ignore
    $event.target.src = '/assets/avatar.png';
  }

  loadListData(): void {
    this.importService.loadImportList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  import(): void {
    const dialogRef = this.dialog.open(OckImportComponent, {
      width: '55%',
      data: {},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

}
